<template>

  <v-toolbar-title>

    <v-list-item class="logo_bar" dark>

      <router-link to="/">

        <v-img
          v-if="$vuetify.breakpoint.smAndDown"
          :src="require('@/styles/Video Platform_mobile.png')"
          height="30"
          width="25"
        />
        <v-img
          v-else
          :src="require('@/styles/Video Platform_white.png')"
          width="140"
          height="37"
        />

      </router-link>
    </v-list-item>

  </v-toolbar-title>
</template>
<script>
export default {
  name: 'AppLogo'
}
</script>

<style scoped>
.logo_bar {
  padding-left: 0px; /* 기본 패딩 */
  padding-right: 8px;
}

@media (max-width: 600px) {
  .logo_bar {
    padding: 0 !important;
  }
}
</style>
